import type { SYSTableDef } from "../../../../../../_ovlclient/src/library/table/tableapi"

export let tblSymbolPCEndUser: SYSTableDef = {
  id: "SPCSymbolPCEndUser",
  feature: "SPCSymbolPC",
  permission: "SPCSP",
  database: {
    dataIdField: "Code",
    dbInsertMode: "UDTAutoGUIDBoth",
  },
  server: {
    endpoint: "symbolpc",
  },
  title: {
    translationKey: "SPCSymbolPCUserPrintersTableTitle",
    dialogTitle: { doNotDisplayId: true },
  },
  options: {
    initial_filter: { static: { U_CardCode: null } },
    initial_sort: { field: "U_Desc", direction: "asc" },
    initial_paging: { page: 0, pageSize: 200 },
    labelAndColumnTitleHandling: { translationPrefix: "SPCSymbolPCCol" },
  },

  features: {
    headerMenu: false,
    add: false,
    edit: true,
  },
  columns: {
    U_Id: {
      ui: { alwaysReadOnly: true },
    },
    U_Desc: {
      sortable: true,
    },
    U_ValidTo: {
      type: "date",
      sortable: true,
      ui: {
        alwaysReadOnly: true,
      },
    },
  },
}
